import { InviteButton } from 'app/components/invite-button';
import { MOBILE_HOME_HEADER_ICON_SIZE } from 'app/components/mobile-home-header-constants';
import { Row } from 'app/design/primitives/box';
import { Platform } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export function MobileHomeHeaderLeft() {
  return (
    <Row
      alignItems="center"
      style={{
        marginLeft: Platform.OS === 'web' ? theme.spacing['spacing.general.x2'] : -theme.spacing['spacing.general.x2'],
      }}
    >
      <InviteButton color={theme.colors['text.primary']} iconSize={MOBILE_HOME_HEADER_ICON_SIZE} />
    </Row>
  );
}
